<template>
  <van-collapse v-model="activeFirst" class="top" @change="resetMainInitial">
    <van-collapse-item  name="1" class="index-top-title">
      <template #title>
        <div class="top-logo-class">
          <van-image :src="require('@/assets/img/index/logo.png')"  class="index-logo"/>
        </div>
      </template>
      <van-collapse v-model="activeSecond" accordion >
        <van-collapse-item title="关于GERM" name="1" >
          <template #right-icon>
            <div v-if="activeSecond == 1" >
              <van-icon name="cross"/>
            </div>
            <!-- 关闭时的图标 -->
            <div v-else>
              <van-icon name="plus"/>
            </div>
          </template>
          <van-cell title="品牌形象大使" @click="jumpSwiper(1,0)"  />
          <van-cell title="品牌故事" @click="jumpSwiper(1,1)"  />
          <van-cell title="定位 愿景 使命" @click="jumpSwiper(1,2)" />
          <van-cell title="用户画像" @click="jumpSwiper(1,3)" />
          <van-cell title="品牌历程" @click="jumpSwiper(1,4)" />
          <van-cell title="全球化战略" @click="jumpSwiper(1,5)" />
        </van-collapse-item>
        <van-collapse-item title="潮流趋势" name="2" class="index-border-top">
          <template #right-icon>
            <div v-if="activeSecond == 2">
              <van-icon name="cross"/>
            </div>
            <!-- 关闭时的图标 -->
            <div v-else>
              <van-icon name="plus"/>
            </div>
          </template>
          <router-link :to="{path: '/product',query:{pid:1}}">
            <van-cell title="2023FESTIVAL/WINTER" />
          </router-link>
          <van-cell title="2023SPRING/SUMMER" @click="jumpSwiper(2,1)"/>
          <van-cell title="2022FESTIVAL/WINTER" @click="jumpSwiper(2,2)"/>
          <van-cell title="2022SPRING/SUMMER" @click="jumpSwiper(2,3)"/>
          <router-link :to="{path: '/product',query:{pid:5}}">
            <van-cell title="潮童出行" />
          </router-link>
        </van-collapse-item>
        <van-cell title="资讯速递" class="index-border-top" @click="jumpSwiper(3,0)">
          <!-- 面板1的内容 -->
        </van-cell>
        <van-cell title="找到我们"  class="index-border-top" @click="jumpSwiper(4,0)">
          <!-- 面板2的内容 -->
        </van-cell>
        <van-cell  class="index-border-top">
          <van-row class="top-link-logo">
            <van-col span="4" @click="showQrCodePopup('tb')">
              <van-image lazy-load :src="require('@/assets/img/index/tb.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('wx')">
              <van-image lazy-load :src="require('@/assets/img/index/wx.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('wb')">
              <van-image lazy-load :src="require('@/assets/img/index/wb.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('xhs')">
              <van-image lazy-load :src="require('@/assets/img/index/xhs.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('dy')">
              <van-image lazy-load :src="require('@/assets/img/index/dy.png')"/>
            </van-col>
          </van-row>
        </van-cell>
      </van-collapse>
    </van-collapse-item>
  </van-collapse>

  <van-swipe @click="handleClickOutside" :initial-swipe="mainInitial"  :loop=false :style="{height:screenHeight+'px'}" :stop-propagation="true"  vertical  :show-indicators="false" @change="onSwiperChange">
    <van-image
        :style="{display:'none'}"
        src="http://cdn-minixxy.apiyoo.net/uploads/20231129/ecfb9ea3cf2685026b632ad678e96228.gif"
        @load="handleGifLoad"
    >
      <!-- 自定义 loading 插槽，不放置任何内容 -->
      <template v-slot:loading></template>
    </van-image>
    <van-swipe-item class="index" :style="{backgroundSize:'cover',backgroundImage:'url(' + indexBgGif + ')' }">
      <van-col span="24">
          <van-image  class="big-title-img"  :src="require('@/assets/img/index/big_title.png')"/>
      </van-col>
      <van-col span="24">
        <van-image @click="showVideoPopup" class="play-botton-img"  :src="require('@/assets/img/index/play_botton.png')"/>
      </van-col>
      <van-image class="down-img"  :src="require('@/assets/img/index/down.png')"/>
      <van-overlay :show="showPopup" :style="{ background: 'rgba(0, 0, 0, 0.8)' }">
        <video ref="videoPlayer" class="index-main-video" controls :style="{width:'100%'}" @ended="videoEnded" @pause="videoEnded">
          <source :src="indexVideo" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        <van-icon name="cross" @click="closeVideoPopup" class="close-icon" />
      </van-overlay>
<!--      <div class="vant-container" :style="{height:(screenHeight-2)+'px'}">-->
<!--        <video-->
<!--            ref="backgroundVideo"-->
<!--            class="background-video"-->
<!--            autoplay-->
<!--            loop-->
<!--            muted-->
<!--            playsinline-->
<!--            @canplaythrough="playVideo"-->
<!--        >-->
<!--          <source :src="require('@/assets/video/index_bg.mp4')" type="video/mp4" />-->
<!--          Your browser does not support the video tag.-->
<!--        </video>-->
<!--        <div class="video-overlay"></div>-->
<!--      </div>-->
    </van-swipe-item>
    <van-swipe-item class="brand" v-lazy:background-image="'http://cdn-minixxy.apiyoo.net/uploads/20231129/779376d4389feed124fc16ed2d338f6b.gif'"
                    :style="{backgroundSize:'cover',backgroundColor:'rgba(255, 255, 255, 0.2)'}">
<!--      <div class="vant-container" :style="{height:(screenHeight-2)+'px',position:'absolute'}">-->
<!--        <video-->
<!--            ref="backgroundVideo"-->
<!--            class="background-video"-->
<!--            autoplay-->
<!--            loop-->
<!--            muted-->
<!--            playsinline-->
<!--            @canplaythrough="playVideo"-->
<!--        >-->
<!--          <source :src="require('@/assets/video/zixun.mp4')" type="video/mp4" />-->
<!--          Your browser does not support the video tag.-->
<!--        </video>-->
<!--      </div>-->
      <van-image class="down-img" :src="brandInitial === 0 ? require('@/assets/img/index/down.png') : require('@/assets/img/brand/down_black.png')"/>
      <van-swipe @change="onBrandSwiperChange" class="my-swipe" :initial-swipe="brandInitial"  :style="{height:screenHeight+'px'}"  indicator-color="black" :height="screenHeight" >
        <van-swipe-item>
          <van-row class="brand-item">
            <van-col span="14"  class="brand-title">品牌大使</van-col>
            <van-col span="24" class="brand-item-span">Ambassador</van-col>
            <van-col span="24" class="content-people-section" :class="{ 'people-show': brandInitial === 0 }">
                <van-image class="brand-people-img" lazy-load :src="require('@/assets/img/brand/brand_people.png')"/>
            </van-col>
            <van-col span="24" class="content-desc-section" :class="{ 'desc-show': brandInitial === 0 }"><van-image class="brand-desc-img" lazy-load :src="require('@/assets/img/brand/brand_desc.png')"/></van-col>

          </van-row>
        </van-swipe-item>
        <van-swipe-item>
          <van-row class="brand-item">
            <van-col span="12" class="brand-title">品牌故事</van-col>
            <van-col span="24" class="brand-item-span">Brand Story</van-col>
            <van-col span="24" class="brand-desc content-section1" :class="{ 'show': brandInitial === 1 }">GERM格沵<br />萌生出美的枝叶，触及城市与人</van-col>
            <van-col span="24" class="brand-desc content-section2" :class="{ 'show': brandInitial === 1 }">创立于2018年<br />为塑造高品质美学生活方式而生<br />希望让更多人认识美、感受美、追求美</van-col>
            <van-col span="24" class="brand-desc content-section3" :class="{ 'show': brandInitial === 1 }">让美好可持续<br />倡议以“续杯”替代一次性纸杯<br />为创建低碳健康的城市生活环境而努力</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item >
          <van-row class="brand-item" >
            <van-col span="14"  class="brand-title content-section1" :class="{ 'show': brandInitial === 2 }">我们的定位</van-col>
            <van-col span="24" class="brand-item-span content-section1" :class="{ 'show': brandInitial === 2 }">Our Position</van-col>
            <van-col span="24" class="content-section1" :class="{ 'show': brandInitial === 2 }"><van-image class="brand-fashion" lazy-load :src="require('@/assets/img/brand/fashion.png')"/></van-col>
            <van-col span="14"  class="brand-title content-section2" :class="{ 'show': brandInitial === 2 }">我们的愿景</van-col>
            <van-col span="24" class="brand-item-span content-section2" :class="{ 'show': brandInitial === 2 }">Our Vision</van-col>
            <van-col span="24" class="position-desc content-section2" :class="{ 'show': brandInitial === 2 }">服务一亿年轻家庭 ，让中国时尚生活美学流行世界</van-col>
            <van-col span="14"  class="brand-title content-section3" :class="{ 'show': brandInitial === 2 }">我们的使命</van-col>
            <van-col span="24" class="brand-item-span content-section3" :class="{ 'show': brandInitial === 2 }">Our Mission</van-col>
            <van-col span="24" class="position-desc content-section3" :class="{ 'show': brandInitial === 2 }">引领精致饮水文化新消费 ，带领人们享受美好生活</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item>
          <van-row class="brand-item">
            <van-col span="14"  class="brand-title">用户画像</van-col>
            <van-col span="24" class="brand-item-span">User Portrait</van-col>
            <van-col span="24"><van-image class="brand-user-img" lazy-load :src="require('@/assets/img/brand/user_img.png')"/></van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item>
          <van-row class="brand-item">
            <van-col span="14"  class="brand-title">品牌历程</van-col>
            <van-col span="24" class="brand-item-span">Milestones</van-col>
            <van-swipe :initial-swipe="historyActive" @change="handleChange" :autoplay="3000" :show-indicators="false" :touchable="false">
              <van-swipe-item v-for="(image, index) in historyList" :key="index" >
                <van-image :src="image" lazy-load class="history-img" style="width: 100%;" />
              </van-swipe-item>
            </van-swipe>
            <!-- 左箭头 -->
            <van-icon class="arrow left-arrow" name="arrow-left" @click="prevImage"/>
            <!-- 右箭头 -->
            <van-icon  class="arrow right-arrow" name="arrow" @click="nextImage"/>
          </van-row>

        </van-swipe-item>
        <van-swipe-item>
          <van-row class="brand-item">
            <van-col span="14" class="brand-title" >全球化战略</van-col>
            <van-col span="24" class="brand-item-span">Milestones</van-col>
            <van-col span="24" class="global-big-title content-section1" :class="{ 'show': brandInitial === 5 }">源自中国 领跑行业 布局全球</van-col>
            <van-col span="24" class="global-small-title content-section1" :class="{ 'show': brandInitial === 5 }">重新定义杯壶行业，5年内全面部署全球化战略</van-col>
            <van-col span="24" class="global-desc content-section2" :class="{ 'show': brandInitial === 5 }">
              超<span class="global-big">5万</span>家门店终端<br />
              多平台的线上店铺、直播间等<span class="global-big">全域渠道</span>布局<br />
              2022年，GERM格沵累计售出<span class="global-big">500万</span>只杯子<br />
              触及千万用户
            </van-col>
            <van-col span="24" class="global-desc2 content-section3" :class="{ 'show': brandInitial === 5 }">
              当前，GERM格沵已全面布局海外市场<br />
              坚定地朝着引领行业的目标前行<br />
              致力于为全球消费者定义新一代的时尚生活美学</van-col>
          </van-row>
        </van-swipe-item>
      </van-swipe>

    </van-swipe-item>
    <van-swipe-item class="chaoliu">
      <van-image class="down-img"  :src="require('@/assets/img/index/down.png')"/>
      <van-swipe  class="my-swipe" :initial-swipe="zixunInitial" :style="{height:screenHeight+'px',width:'100vw'}"  indicator-color="white" :autoplay="3000" :height="screenHeight" :show-indicators="false">
        <van-swipe-item v-lazy:background-image="chaoliu_bg1" :style="{backgroundSize:'cover',width: '100vw'}">
          <van-row class="product-item" justify="center" >
            <van-col span="24">
              <router-link :to="{path: '/product',query:{pid:1}}">
                <van-image class="chaoliu-button1" :src="require('@/assets/img/chaoliu/button1.png')" />
              </router-link>
            </van-col>
            <van-col span="24" class="product-en-title">2023FESTIVAL/WINTER</van-col>
            <van-col span="24" class="product-bottom-msg">以先锐产品创意注入设计之中<br/>作为未来潮奢生活的预演，向着杯壶世界无限延伸。潮不逐流，创造<br/>从不设限，这一季，属于热爱的流派。</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item v-lazy:background-image="chaoliu_bg2" :style="{backgroundSize:'cover',width: '100vw'}">
          <van-row class="product-item" justify="center" >
            <van-col span="24" >
              <van-image class="chaoliu-button2" :src="require('@/assets/img/chaoliu/button2.png')" />
            </van-col>
            <van-col span="24" class="product-en-title">2022SPERING/SUMMER</van-col>
            <van-col span="24" class="product-bottom-msg">元气，飒气，稚气<br/>实用与好看的默契配合塑造你的百变气场。面向未来，与世界再一次发生<br/>深刻联系，让「自我」在生活方式里充分涌流。</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item v-lazy:background-image="chaoliu_bg3" :style="{backgroundSize:'cover',width: '100vw'}">
          <van-row class="product-item" justify="center" >
            <van-col span="24" >
              <van-image class="chaoliu-button3" :src="require('@/assets/img/chaoliu/button3.png')" />
            </van-col>
            <van-col span="24" class="product-en-title">2022FESTIVAL/WINTER</van-col>
            <van-col span="24" class="product-bottom-msg">WE NEED A FRESH START<br/>GERM推动杯壶潮流，重塑美好的新生。让看似不起眼的好物，成为<br/>点亮平淡生活的魔法。</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item v-lazy:background-image="chaoliu_bg4" :style="{backgroundSize:'cover',width: '100vw'}">
          <van-row class="product-item" justify="center" >
            <van-col span="24" >
              <van-image class="chaoliu-button3" :src="require('@/assets/img/chaoliu/button4.png')" />
            </van-col>
            <van-col span="24" class="product-en-title">2022SPERING/SUMMER</van-col>
            <van-col span="24" class="product-bottom-msg">潮出行，超有型<br/>拒绝千篇一律，多元杯壶风格延伸多面穿搭灵感。随饮随行之间，让<br/>杯子成为风格点睛的时尚ICON。</van-col>
          </van-row>
        </van-swipe-item>
        <van-swipe-item v-lazy:background-image="chaoliu_bg5" :style="{backgroundSize:'cover',width: '100vw'}">
          <van-row class="product-item" justify="center" >
            <van-col span="24" >
              <router-link :to="{path: '/product',query:{pid:5}}">
                <van-image class="chaoliu-button3" :src="require('@/assets/img/chaoliu/button5.png')" />
              </router-link>
            </van-col>
            <van-col span="24" class="product-en-title">2023Stylish Kids' Travel</van-col>
            <van-col span="24" class="product-bottom-msg">儿童出行线以原创设计为主<br/>产品集高颜值、创新性、轻便实用等特点于一身，专为孩子上学运动、<br/>户外出游定制百搭潮流背包，多方面展现新世代潮童出行的时尚态度。</van-col>
          </van-row>
        </van-swipe-item>
      </van-swipe>
    </van-swipe-item>
    <van-swipe-item v-lazy:background-image="'http://cdn-minixxy.apiyoo.net/uploads/20231129/779376d4389feed124fc16ed2d338f6b.gif'" :style="{backgroundSize:'cover'}">
      <div class="zixun">
        <van-row class="brand-item">
          <van-col span="14" class="zixun-title">资讯速递</van-col>
          <van-col span="24" class="brand-item-span">User Portrait</van-col>
        </van-row>
        <van-image class="down-img" :src="require('@/assets/img/brand/down_black.png')"/>
        <!-- 切换的内容 -->
        <div class="zixun-tab-layout">
          <div class="zixun-image-container">
            <van-swipe  :initial-swipe="activeTab" class="zixun-image-swipe" :touchable="false" :show-indicators="false">
              <van-swipe-item>
                <van-image lazy-load :src="require('@/assets/img/zixun/zixun_index_1.png')"  />
              </van-swipe-item>
              <van-swipe-item>
                <van-image lazy-load :src="require('@/assets/img/zixun/zixun_index_2.png')" />
              </van-swipe-item>
              <van-swipe-item>
                <van-image lazy-load :src="require('@/assets/img/zixun/zixun_index_3.png')" />
              </van-swipe-item>
            </van-swipe>
          </div>
          <!-- 切换的内容 -->
          <van-swipe  :initial-swipe="activeTab" class="zixun-content-swipe" :touchable="false" :show-indicators="false">
            <van-swipe-item>
              <!-- 内容1 -->
              <router-link to="/zixun">
                <p>GERM品牌大使-李小冉</p>
                <p><van-image lazy-load :src="require('@/assets/img/zixun/read_more.png')" />
                  <van-image class="zixun-arrow" lazy-load :src="require('@/assets/img/zixun/arrow1.png')" />
                </p>
              </router-link>
            </van-swipe-item>
            <van-swipe-item>
              <router-link to="/zixun">
                <p>2023秋冬潮流趋势发布</p>
                <p><van-image lazy-load :src="require('@/assets/img/zixun/read_more.png')" />
                  <van-image class="zixun-arrow" lazy-load :src="require('@/assets/img/zixun/arrow1.png')" />
                </p>
              </router-link>
            </van-swipe-item>
            <van-swipe-item>
              <router-link to="/zixun">
                <p>国庆特刊—尽看中国潮</p>
                <p><van-image lazy-load :src="require('@/assets/img/zixun/read_more.png')" />
                  <van-image class="zixun-arrow" lazy-load :src="require('@/assets/img/zixun/arrow1.png')" />
                </p>
              </router-link>
            </van-swipe-item>
          </van-swipe>
          <!-- Tab 标签栏 -->
          <van-tabs v-model="activeTab" @click-tab="handleTabClick" class="zixun-tab-container">
            <van-tab title="1"></van-tab>
            <van-tab title="2"></van-tab>
            <van-tab title="3"></van-tab>
          </van-tabs>
        </div>
        <div class="zixun-desc">
          <!-- 切换的内容 -->
          <van-swipe  :initial-swipe="activeTab"  :show-indicators="false" :touchable="false">
            <van-swipe-item>
              <p>她，是颜值与演技双双在线的国民女神<br/>
                她，塑造了很多深入人心的荧屏经典角色 <br/>
                她，是国内最受观众欢迎的的女演员之一 <br />
                她，展现着女性勇敢追逐自我的人生态度 <br /><br />
                致力于创造高品质生活的时尚杯壶品牌GERM，近日官宣李小冉成为品牌大使。自创立以来，GERM改变了人们对国货杯壶的传统看法，开辟了行业新风向。
                此次与李小冉的成功牵手，将以好杯子致意热爱，展示杯壶在百变场景中的多面演绎。 <br><br />
                在保持生活仪式感的回答中，李小冉与GERM有许多共通之处，
                杯壶界“国货之光”与演艺界“国民女神”的双向奔赴，共同探寻美好生活主张。 <br /><br />
                不拘场景,补水每时每刻无畏季节,为你强效锁温不惧目光,勇敢“自带杯“</p>
            </van-swipe-item>
            <van-swipe-item>
              <p>随着越来越时尚化、年轻化的消费趋势，追求品质、彰显个性的90后、00后已经成为新时代的消费主力军。他们不仅敢于消费，也更愿意尝试新鲜事物，
                敢于表达对美的需求。Germ格沵将目光更多地聚焦年轻消费者，以时尚的品味和专业的设计，将生活用品与时尚潮流融为一体，在生活用品领域不断推陈出新，
                沉淀品牌实力。
                <br />  <br />
                产品不仅是生活方式的注脚，也是追求与态度的体现。随着年轻一代消费客群形成，生活类产品在承接本身实用性能以外，更要衍生出多样功能用以满足年轻人的不同需求。
                拿杯壶举例，除了满足饮水等专用功能外，杯壶已逐渐成为用户彰显个性的重要时尚单品，消费频次越来越高。杯壶的配饰化，要求其必须具备较高潮流度，
                这就需要品牌足够懂年轻人。Germ格沵杯壶在产品设计上，时刻把握最新潮流资讯，保持与年轻消费者喜好的高频率沟通，了解他们的最新喜好，不断创新，
                争取在每个阶段给年轻消费者带来全新体验。</p>
            </van-swipe-item>
            <van-swipe-item>
              <p>从古时盛宴的“觥筹交错”，到《兰亭序》里的“曲水流觞”，再到宋代的绝色汝瓷杯，国人对杯子的要求始终考究。进入现代，饮具依然是日常生活中必不可少的一部分，
                从宋代沿袭下来的“茶事”演变成为今日的泡茶、煮咖啡、自制饮品......湖泡学问和品饮功夫深藏国人心中。
                <br /> <br />
                GERM希望，通过国潮传递出潮流时尚里的中国气质，不刻意堆砌国风元素，更不必硬凹东方美学。用创新的杯壶设计表达，阐述新国潮力量。用中国好杯子，
                诠释中国潮流用国际化语言,阐述中国故事。
                <br /> <br />
                当国潮以势不可挡的步伐走向世界，面向未来，GERM不停止探索，不断自我进化，势让中国杯壶品牌在世界舞台上尽显光亮。
                <br /> <br />
                艺术不是高岭之花，应当深入生活GERM杯壶世界，国潮酷到尖叫！</p>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
<!--      <div class="vant-container" :style="{height:(screenHeight-2)+'px'}">-->
<!--        <video-->
<!--            ref="backgroundVideo"-->
<!--            class="background-video"-->
<!--            autoplay-->
<!--            loop-->
<!--            muted-->
<!--            playsinline-->
<!--            @canplaythrough="playVideo"-->
<!--        >-->
<!--          <source :src="require('@/assets/video/zixun.mp4')" type="video/mp4" />-->
<!--          Your browser does not support the video tag.-->
<!--        </video>-->
<!--      </div>-->
    </van-swipe-item>
    <van-swipe-item class="join-us" :style="{backgroundSize:'cover',backgroundImage:'url(' + indexBgGif + ')' }">
      <van-col span="24">
        <van-image class="join-img" lazy-load :src="require('@/assets/img/join_us.png')"/>
      </van-col>
      <van-image class="down-img"  :src="require('@/assets/img/index/down.png')"/>
<!--      <div class="vant-container" :style="{height:(screenHeight-2)+'px'}">-->
<!--        <video-->
<!--            ref="backgroundVideo"-->
<!--            class="background-video"-->
<!--            autoplay-->
<!--            loop-->
<!--            muted-->
<!--            playsinline-->
<!--            @canplaythrough="playVideo"-->
<!--        >-->
<!--          <source :src="require('@/assets/video/join_us.mp4')" type="video/mp4" />-->
<!--          Your browser does not support the video tag.-->
<!--        </video>-->
<!--        <div class="video-overlay"></div>-->
<!--      </div>-->
    </van-swipe-item>
    <van-swipe-item class="footer">
      <van-divider class="footer-title">线下合作</van-divider>
      <van-swipe class="my-swipe footer-xianxia"  indicator-color="black" :autoplay="3000" >
        <van-swipe-item>
          <van-image lazy-load :src="require('@/assets/img/footer/shuma.png')"/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image lazy-load :src="require('@/assets/img/footer/chuantong.png')"/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image lazy-load  :src="require('@/assets/img/footer/chaopin.png')"/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image lazy-load :src="require('@/assets/img/footer/jiaju.png')"/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image lazy-load :src="require('@/assets/img/footer/jinkou.png')"/>
        </van-swipe-item>
        <van-swipe-item>
          <van-image lazy-load :src="require('@/assets/img/footer/muying.png')"/>
        </van-swipe-item>
      </van-swipe>
      <van-divider class="footer-title">线上渠道</van-divider>
      <van-row gutter="5" class="footer-xianshang">
        <van-col span="4" @click="showQrCodePopup('tm')">
          <van-image lazy-load :src="require('@/assets/img/footer/tianmaod.png')"/>
        </van-col>
        <van-col span="4" @click="showQrCodePopup('jd')">
          <van-image lazy-load :src="require('@/assets/img/footer/jingdongd.png')"/>
        </van-col>
        <van-col span="4" @click="showQrCodePopup('pdd')">
          <van-image lazy-load :src="require('@/assets/img/footer/pingduoduod.png')"/>
        </van-col>
        <van-col span="4" @click="showQrCodePopup('wph')">
          <van-image lazy-load :src="require('@/assets/img/footer/weipind.png')"/>
        </van-col>
        <van-col span="4">
          <van-image lazy-load :src="require('@/assets/img/footer/dewud.png')"/>
        </van-col>
        <van-col span="4" @click="showQrCodePopup('dy')">
          <van-image lazy-load :src="require('@/assets/img/footer/douyind.png')"/>
        </van-col>
      </van-row>
      <van-divider class="footer-title">更多好玩</van-divider>
      <van-row gutter="20" class="footer-gengduo">
        <van-col span="6" @click="showQrCodePopup('wx')">
          <van-image lazy-load :src="require('@/assets/img/footer/weixin.png')"/>
        </van-col>
        <van-col span="6" @click="showQrCodePopup('wb')">
          <van-image lazy-load :src="require('@/assets/img/footer/weibo.png')"/>
        </van-col>
        <van-col span="6" @click="showQrCodePopup('xhs')">
          <van-image lazy-load :src="require('@/assets/img/footer/redbook.png')"/>
        </van-col>
        <van-col span="6" @click="showQrCodePopup('dy')">
          <van-image lazy-load :src="require('@/assets/img/footer/douyin.png')"/>
        </van-col>
      </van-row>
      <van-row gutter="20" class="footer-brand">
        <van-col span="24">
          <van-image lazy-load :src="require('@/assets/img/footer/brand_logo.png')"/>
        </van-col>
      </van-row>

    </van-swipe-item>
  </van-swipe>
  <van-popup v-model:show="showQrcode">
    <!-- 弹框内容 -->
    <div class="qr-code-container">
      <van-image class="qrcode-img" :src="qrcodeUrl" alt="QR Code"/>
      <!-- 关闭按钮 -->
      <van-icon class="close-icon" name="close" @click="closeQrCodePopup"/>
    </div>
  </van-popup>
</template>
<script>

import { Swipe, SwipeItem,Cell,Popup,Icon,Collapse, CollapseItem,Col,Row,Button,Divider,Image,Tab,Tabs,Overlay,Lazyload} from 'vant';
 // import { ref } from 'vue';
export default {
  components:{
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem,
    [Cell.name]:Cell,
    [Popup.name]:Popup,
    [Icon.name]:Icon,
    [Collapse.name]:Collapse,
    [CollapseItem.name]:CollapseItem,
    [Col.name]:Col,
    [Row.name]:Row,
    [Button.name]:Button,
    [Divider.name]:Divider,
    [Image.name]:Image,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Overlay.name]:Overlay,
    [Lazyload.name]:Lazyload,
  },

  data(){
    return{
      indexVideo:require('@/assets/video/index.mp4'),
      screenHeight:896,
      activeFirst: [],
      activeSecond: 0,
      activeTab:0,
      showPopup: false,
      chaoliu_bg1:require('@/assets/img/chaoliu/background1.jpg'),
      chaoliu_bg2:require('@/assets/img/chaoliu/background2.jpg'),
      chaoliu_bg3:require('@/assets/img/chaoliu/background3.jpg'),
      chaoliu_bg4:require('@/assets/img/chaoliu/background4.jpg'),
      chaoliu_bg5:require('@/assets/img/chaoliu/background5.jpg'),
      historyList:[
        require('@/assets/img/brand/history1.png'),
        require('@/assets/img/brand/history2.png'),
        require('@/assets/img/brand/history3.png'),
        require('@/assets/img/brand/history4.png'),
        require('@/assets/img/brand/history5.png'),
        require('@/assets/img/brand/history6.png'),
      ],
      qrcodeList: {
        tm: require('@/assets/img/qrcode/tm.png'),
        jd: require('@/assets/img/qrcode/jd.png'),
        pdd: require('@/assets/img/qrcode/pdd.png'),
        wph: require('@/assets/img/qrcode/wph.png'),
        dy: require('@/assets/img/qrcode/dy.png'),
        wx: require('@/assets/img/qrcode/wx.png'),
        xhs: require('@/assets/img/qrcode/xhs.png'),
        wb: require('@/assets/img/qrcode/wb.png'),
        tb: require('@/assets/img/qrcode/tb.png'),
      },
      qrcodeUrl:require('@/assets/img/qrcode/wb.png'),
      showQrcode:false,
      historyActive:0,
      mainInitial:0,
      zixunInitial:0,
      brandInitial:null,
      currentIndex:0,
      indexBgGif:require('@/assets/img/index_bg.jpg'),
    }
  },
  created() {
    this.getScreenHeight();
  },
  mounted() {
    // 获取参数
    const mIndex = this.$route.query.mIndex;
    const zIndex = this.$route.query.zIndex;
    const bIndex = this.$route.query.bIndex;
    if(mIndex && mIndex > 0){
      this.mainInitial = mIndex;
      if(zIndex && zIndex >= 0){
        this.zixunInitial = parseInt(zIndex);
      }
      if(bIndex && bIndex >= 0){
        this.brandInitial = parseInt(bIndex);
      }
    }
  },
  methods: {
    getScreenHeight() {
      this.screenHeight = window.innerHeight -(window.innerWidth/430*44);
    },
    onSwiperChange(currentIndex) {
      // 在 Swiper 切换到新的轮播项时触发
      this.currentIndex = currentIndex;
      if(currentIndex == 1){
        this.brandInitial = 0;
      }else{
        this.brandInitial = null;
      }
    },
    onBrandSwiperChange(brandIndex) {
      this.brandInitial = brandIndex;
    },
    handleClickOutside() {// 收起折叠面板
      if (this.activeFirst.length > 0 ) {
        this.activeFirst = [];
      }
    },
    playVideo() {
      const video = this.$refs.backgroundVideo;
      video.play().catch((error) => {
        console.error("Autoplay prevented: ", error);
      });
    },
    handleTabClick(index) {
      // 当 Tab 被点击时，更新 activeTab
      this.activeTab = index.name;
    },
    showVideoPopup() {
      this.showPopup = true;
      this.$nextTick(() => {
        this.playIndexVideo();
      });
    },
    playIndexVideo() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.play();
        // videoPlayer.requestFullscreen(); // 请求全屏
      }
    },
    closeVideoPopup() {
      this.showPopup = false;
      // 在关闭弹窗时，可以暂停视频
      const videoPlayer = this.$refs.videoPlayer;
      videoPlayer.pause();
    },
    videoEnded(){
      this.closeVideoPopup();
    },
    handleChange(index) {
      this.historyActive = index;
    },
    prevImage() {
      this.historyActive = (this.historyActive - 1 + this.historyList.length) % this.historyList.length;
    },
    nextImage() {
      this.historyActive = (this.historyActive + 1) % this.historyList.length;
    },
    showQrCodePopup(type) {
      this.showQrcode = true;
      this.qrcodeUrl = this.qrcodeList[type];
    },
    closeQrCodePopup() {
      this.showQrcode = false;
    },
    jumpSwiper(main_index,child_index){
      this.activeFirst = [];
      if(main_index >= 0){
        this.mainInitial =main_index;
      }
      if(main_index == 1){
        this.brandInitial = child_index;
      }else if(main_index == 2){
        this.zixunInitial = child_index;
      }
    },
    resetMainInitial(){
      this.mainInitial =this.currentIndex;
    },
    handleGifLoad(){
      this.indexBgGif = 'http://cdn-minixxy.apiyoo.net/uploads/20231129/ecfb9ea3cf2685026b632ad678e96228.gif';
    },
  },

}
</script>
<style>
body{
  font-family: OPPOSans;
  background: #FFF;
}
.van-swipe-item {
  color: #000;
  font-size: 20px;
  text-align: center;
  overflow: auto;
}
.plus-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-collapse-item__content .van-cell:after{
  border-top: 0;
}
.van-collapse-item__title--expanded:after{
  display: none;
}
 .index-border-top{
  border-top: 1px solid #000;
}
 .index-top-title .van-cell--clickable:not(.van-collapse-item__wrapper .van-cell--clickable){
   padding-bottom: 0px;
   padding-left: 28px;
   padding-right: 28px;
 }
.index-logo img{
  width: 96px;
  height: 35px;
}
.top [class*=van-hairline]:after{
  border:0;
}
.top .van-collapse-item__content{
  padding-bottom: 0px;
}
.top .top-link-logo img{
  width: 53px;
  height: 25px;
}
.top .van-icon-arrow:before{
  font-size: 35px;
  padding-top: 10px;
  color: #000;
}
.brand-item{
  padding-left:24px;
  text-align:left;
  margin-top:80px;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0em;
  color: #000000;
}

.product-item{
  padding-left:24px;
  text-align:center;
  position: absolute;
  top:66%;
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  color: #fff;
}
.product-item .van-col{
  padding-bottom: 10px;
}
.product-item .van-button{
  height: 30px;
}
.product-item .product-en-title{
  font-family: GoodSansAlt-Medium-Medium;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
}
.product-item .product-bottom-msg{
  font-size: 12px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: -0.03em;
}
.brand-item .global-big{
  font-size: 24px;
}
.brand-item .global-desc2{
  font-size: 16px;
  font-weight: normal;
  line-height: 32px;
  padding-top: 37px;
}
.brand-item .global-desc{
  font-size: 16px;
  font-weight: normal;
  line-height: 40px;
  padding-top: 49px;
}

.brand-item .global-big-title{
  font-size: 30px;
  font-weight: 500;
  line-height: normal;
  padding-top: 11px;
}
.brand-item .global-small-title{
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  padding-top: 11px;
}
.footer-xianshang img{
  width:53px;
  height: 53px;
}
.footer-xianxia img{
  width:370px;
  height: 170px;
}
.footer-gengduo img{
  width:47px;
  height: 37px;
}
.footer-brand{
  padding: 20px 0;
}
.footer-brand img{
  width:370px;
  height: 181px;
  padding-top: 10px;
}
.footer-title{
  color: #000;
  border-color: #000;
  padding: 20px 15px
}
.join-us .join-img img{
  width: 272px;
  height: 387px;
  text-align: center;
  padding-top: 150px;
  position: absolute;
  z-index: 1;
}
.join-us img{
  padding-top: 0;
}
.join-us .join-img,.index .van-image{
  display: flex;
  justify-content: center;
}
.index .big-title-img img{
  width: 341px;
  height: 137px;
  text-align: center;
  padding-top: 260px;
  position: absolute;
  z-index: 1;
}
.index .play-botton-img img{
  width: 72px;
  height: 35px;
  text-align: center;
  margin-top: 452px;
  position: absolute;
  z-index: 1;
}
 .down-img img{
  width: 30px;
  height: 30px;
  text-align: center;
  position: absolute;
  z-index: 3;
  animation: floatUpDown 2s infinite ease-in-out;
}
.down-img{
  position: absolute;
  top: 92%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  width: 100%;
}


@keyframes floatUpDown {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-25px);
  }
}

 .vant-container {
   position: relative;
   width: 430px;
 }

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.2;
}
 .video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.join-us .video-overlay{
  background-color: rgba(0, 0, 0, 0.35); /* 35% 透明度的黑色遮罩 */
}
.index .video-overlay{
  background-color: rgba(0, 0, 0, 0.7); /* 70% 透明度的黑色遮罩 */
}
.zixun{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.zixun .zixun-title{
  font-size: 21px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
}
.zixun-tab-layout {
  display: flex;
}

.zixun-image-container {
  flex: 1;
}

.zixun-tab-container {
  position: absolute;
  margin-top:146px;
  left: 190px;
  width: 200px;
  padding-left: 14px;
  z-index: 10;
}
.zixun-image-swipe{
  width: 204px;
}
.zixun-image-swipe img{
  width: 204px;
  height: 190px;
}
.zixun-image-swipe .van-swipe-item{
  width: 33.33%;
}
.zixun-content-swipe {
  /*height: 200px; !* 根据实际需要调整高度 *!*/
  top: 10px;
  margin-left: 60px;
  overflow-x: hidden;
  /*height: 200px; !* 根据实际需要调整高度 *!*/
  left: -46px;
  z-index:10;
}
.zixun-content-swipe .van-swipe-item{
  text-align: left;
}
.zixun .zixun-content-swipe img{
  height: 15px;
  width: 70px;
}
.zixun .zixun-arrow{
  margin-left: 20px;
  animation: floatLeftRight 2s infinite ease-in-out;
}

@keyframes floatLeftRight {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(35px);
  }
}

.zixun .zixun-arrow img{
  height: 15px;
  width: 34px;
}

.zixun .zixun-content-swipe p{
  font-size: 16px;
  font-weight: 500;
  line-height: 45px;
  letter-spacing: 0em;
  color: #000;
}
.zixun .van-tabs__nav{
  background:none;
}
.zixun .van-tabs__line{
  display: none;
}
.zixun .van-tab{
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 11px;
  width: 29px;
  height: 29px;
  box-sizing: border-box;
  border: 1.2px solid #808080;
  padding: 0 0;
  border-radius: 5px;
  flex: 0 0 auto;
  font-size: 20px;
}
.zixun .van-tab--active{
  width: 35px;
  height: 35px;
  border: 1.7px solid #000;
  font-size: 20px;
}
.zixun .zixun-desc p{
  font-size: 10px;
  font-weight: normal;
  line-height: 19px;
  text-align: justify; /* 浏览器可能不支持 */
  letter-spacing: 0em;
  color: #3D3D3D;
  padding: 0 40px;
}
.chaoliu .my-swipe .van-swipe-item{
  height: 100%;
}
.chaoliu .van-image{
  animation: breathAnimation 2s infinite ease-in-out;
}
.chaoliu .chaoliu-button1{
  width: 136px;
  height: 36px;
}
.chaoliu .chaoliu-button2{
  width: 170px;
  height: 36px;
}
.chaoliu .chaoliu-button3{
  width: 106px;
  height: 36px;
}

@keyframes breathAnimation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.brand .brand-title{
  font-size: 21px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #000000;
}
.brand .brand-item-span,.zixun .brand-item-span{
  font-family: GoodSansAlt-Medium-Medium;
  font-size: 10px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  color: #969696;
  white-space: normal;
  padding-left: 54px;
  padding-bottom: 0px;
}

.brand .brand-desc{
  font-family: OPPOSans;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0em;
  color: #000000;
  padding-top: 31px;
}
.brand .brand-fashion{
  padding: 31px 0;
}
.brand .brand-fashion img{
  width: 252px;
  height: 47px;
}
.brand .position-desc{
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0em;
  color: #000000;
  padding-top: 31px;
  padding-bottom: 56px;
}
.brand .brand-user-img{
  padding-top: 19px;
}
.brand .brand-user-img img{
  width: 392px;
  height: 353px;
}
.brand .brand-people-img{

  justify-content: flex-end;

}
.brand .brand-people-img img{
  width: 328px;
  height: 619px;
}
.brand .brand-desc-img{
  display: flex;
  justify-content: flex-start;
  /*position: absolute;*/
  /*top: 356px;*/
}
.brand .brand-desc-img img{
  width: 182px;
  height: 226px;
}
.brand .arrow {
  position: absolute;
  top: 48%;
  transform: translateY(-50%);
  font-size: 24px;
  color: #333;
  cursor: pointer;
}
.brand .left-arrow {
  left: 20px;
  border: 1px solid;
}

.brand .right-arrow {
  right: 20px;
  border: 1px solid;
}
.brand .history-img{
  padding-top: 20px;
}
.brand .history-img img{
  width: 384px;
  height: 430px;
}

.qr-code-container .qrcode-img img {
  width: 180px;
  height: 210px;
}

.qr-code-container .close-icon {
  position: absolute;
  font-size: 32px;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  bottom: 14%;
  right: 42%;

}
 .van-popup{
  background: none;
   top:45%;
   height: 300px;
}
.fade-content {
  opacity: 0;
  transform: translateY(20px);
}

.content-desc-section{
  position: absolute;
  bottom: 36%;
  opacity: 0; /* 初始时设置透明度为0 */
  transform: translateY(40px); /* 初始时向上平移一定距离 */
  transition: opacity 2s ease, transform 2s ease; /* 过渡效果，可根据需要调整时间和缓动函数 */
}
.content-desc-section.desc-show{
  opacity: 1; /* 设置透明度为1，显示内容 */
  transform: translateY(0); /* 向上平移复位 */
}

.content-people-section{
  position: absolute;
  line-height: 0;
  right: 0;
  bottom: 0;
  opacity: 0; /* 初始时设置透明度为0 */
  transform: translateX(60px); /* 初始时向右平移一定距离 */
  transition: opacity 2s ease, transform 2s ease; /* 过渡效果，可根据需要调整时间和缓动函数 */
}
.content-people-section.people-show{
  opacity: 1; /* 设置透明度为1，显示内容 */
  transform: translateX(0px); /* 向右平移复位 */
}

.content-section1 {
  opacity: 0; /* 初始时设置透明度为0 */
  transform: translateY(40px); /* 初始时向上平移一定距离 */
  transition: opacity 1s ease, transform 1s ease; /* 过渡效果，可根据需要调整时间和缓动函数 */
}
.content-section2 {
  opacity: 0; /* 初始时设置透明度为0 */
  transform: translateY(40px); /* 初始时向上平移一定距离 */
  transition: opacity 2s ease, transform 2s ease; /* 过渡效果，可根据需要调整时间和缓动函数 */
}
.content-section3 {
  opacity: 0; /* 初始时设置透明度为0 */
  transform: translateY(40px); /* 初始时向上平移一定距离 */
  transition: opacity 3s ease, transform 3s ease; /* 过渡效果，可根据需要调整时间和缓动函数 */
}

.content-section1.show,.content-section2.show,.content-section3.show {
  opacity: 1; /* 设置透明度为1，显示内容 */
  transform: translateY(0); /* 向上平移复位 */
}
.index .index-main-video{
  margin-top:248px
}
.index .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}
.brand .van-swipe__indicators{
  top:85%;
}



</style>
